import { authAPIUrl, webappUrl } from "@/environment";
import { captureExceptionWithContext } from "@/sentry";
import AuthService from "@/services/auth.service";
import { lazyRoute } from "@/utils/load";

const ProcurementPage = lazyRoute(() => import("@/pages/ProcurementPage.vue"));
const LicensesPaidPage = lazyRoute(() => import("@/pages/LicensesPaidPage.vue"));
const RegisterPage = lazyRoute(() => import("@/pages/RegisterPage.vue"));
const SetupPage = lazyRoute(() => import("@/pages/SetupPage.vue"));
const TrainingPage = lazyRoute(() => import("@/pages/TrainingPage.vue"));

async function loginWithFusionAuth() {
  try {
    var res = await AuthService.isAuthenticated();
  } catch (error) {
    if (error.response?.data?.error?.code === "TOKEN_EXPIRED") {
      // Token expired with expected error code, handle it
      try {
        await AuthService.refreshToken();
        return { name: "home" };
      } catch (refreshError) {
        return redirectAfterError(refreshError);
      }
    }
    return redirectAfterError(error);
  }

  if (res?.data?.success) {
    return { name: "home" };
  }

  const unexpectedError = new Error("Unexpected response when checking if user is authenticated");
  return redirectAfterError(unexpectedError, {
    responseURL: res?.request?.responseURL,
    response: res?.data,
  });
}

function redirectAfterError(error, extraContext = {}) {
  void captureExceptionWithContext(error, {
    errorMessage: error?.message,
    ...extraContext,
  });
  window.location.assign(authAPIUrl + "/auth/login?type=admin");
  return false;
}

async function redirectIfAuthenticated() {
  try {
    const res = await AuthService.isAuthenticatedSilent();
    if (res?.data?.success) {
      window.location.replace(webappUrl);
      return false;
    }
  } catch {
    // fall through and allow navigation
  }
}

export function getPublicPagesRoutes() {
  return [
    {
      path: "/login",
      alias: "/",
      name: "login",
      beforeEnter: loginWithFusionAuth,
    },
    {
      path: "/register",
      name: "register",
      component: RegisterPage,
      beforeEnter: redirectIfAuthenticated,
      meta: { isCloud: true, hideMenu: true, gtm: true },
    },
    {
      path: "/onprem-register",
      name: "onprem-register",
      component: RegisterPage,
      beforeEnter: redirectIfAuthenticated,
      meta: { onPrem: true, hideMenu: true, gtm: true },
    },
    {
      path: "/remotetraining",
      name: "remotetraining",
      component: TrainingPage,
      meta: { isCloud: true, hideMenu: true, gtm: true },
    },
    {
      path: "/setup",
      name: "setup",
      async beforeEnter() {
        const isAllowed = await AuthService.canSetup();
        return isAllowed ? undefined : "/";
      },
      component: SetupPage,
      meta: { isCloud: false, hideMenu: true, gtm: true },
    },
    {
      path: "/procurement",
      name: "procurement",
      component: ProcurementPage,
      meta: { hideMenu: true, gtm: true },
    },
    {
      path: "/payed",
      name: "payed",
      component: LicensesPaidPage,
      meta: { hideMenu: true, gtm: true },
    },
  ];
}
